var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1683",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11048",
    d: "M4.084-13.293a2 2 0 0 1 2.831 0l.378.378a2 2 0 0 1 0 2.83L.406-3.2a2.231 2.231 0 0 1-.963.534l-2.831.653a.5.5 0 0 1-.466-.134.5.5 0 0 1-.134-.466l.653-2.831a2.2 2.2 0 0 1 .535-.99zm2.122.707a1 1 0 0 0-1.413 0l-.837.836L5.75-9.956l.834-.837a1 1 0 0 0 0-1.413zm-8.565 7.367-.475 2.053 2.025-.475A.839.839 0 0 0-.3-3.934L5.044-9.25 3.25-11.043-2.094-5.7a.993.993 0 0 0-.265.481zM-1.5-12a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5h-4A1.5 1.5 0 0 0-7-9.5v9A1.5 1.5 0 0 0-5.5 1h9A1.5 1.5 0 0 0 5-.5v-4a.5.5 0 0 1 .5-.5.5.5 0 0 1 .5.5v4A2.5 2.5 0 0 1 3.5 2h-9A2.5 2.5 0 0 1-8-.5v-9A2.5 2.5 0 0 1-5.5-12z",
    transform: "translate(10 16)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".1px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9cf03f90be26189d1b14eb29f3916e53.svg";
export { ForwardRef as ReactComponent };